'use strict';

import 'angular';

import directive from './directive';

const MODULE_NAME = 'brg.maps.autocomplete';

var app = angular.module(MODULE_NAME, []);
app.directive('brgMapsAutocomplete', directive);

export default MODULE_NAME;
